import axios from "axios";
import constants from "@/constants";

function getToken(typeChange = "") {

    const account = JSON.parse(localStorage.getItem('account'))
    let headers
    if (typeChange !== "") {
        headers = new Map(Object.entries({'Content-type': typeChange}));
    } else {
        headers = new Map(Object.entries({'Content-type': 'application/json'}));
    }

    if (account && account.authorization) {
        headers.set('Authorization', account.authorization);
        headers.set('token', account.token);
    }

    return Object.fromEntries(headers)

}

export let customAxios = axios.create({
    baseURL: constants.baseURL,
})

customAxios.interceptors.response.use((response) => response, (error) => {

    if (error.response && error.response.status === 401) {

        const path = error.response.data.path

        if (path !== "/v1/login" && path !== "/v1/general/my-user/changePassword") {
            window.location.href = "/login?logout=yes";
        }

    } else if (error.response && error.response.status === 406) {

        console.log(error.response)
        alert('Você não possui acesso ao recurso que esta tentando acessar.')

        //window.location.href = "/home?msg=not-acceptable";

    }

    return Promise.reject(error);

})

const get = async function (path) {
    return customAxios.get(path, {
        headers: getToken()
    });
}

const getAssemble = async function (path, type, params) {

    let url = "/assemble"

    if (type !== '') {

        url += "?type=" + type

        if (params && Array.from(params).length > 0) {
            url += `&${params}`
        }

    }

    return customAxios.get(path + url, {
        headers: getToken()
    });
}


const getAll = async function (path, pageNumber_ = 1, params) {

    let pageNumber = 0;

    if (isNaN(pageNumber_)) {
        pageNumber = 1;
    } else {
        pageNumber = pageNumber_;
    }

    let url = `?page=${pageNumber}`

    if (params && Array.from(params).length > 0) {
        url += `&${params}`
    }

    return customAxios.get(path + url, {
        headers: getToken()
    });

}

const getById = async function (path, id, forceReadById = false) {

    let pathSend = path

    if (path.substring(path.length - 1) !== '/') {
        pathSend = pathSend + "/"
    }

    pathSend += id

    if (forceReadById) {
        pathSend += "/?forceReadById=true&teste=SIM"
    }

    return customAxios.get(pathSend, {
        headers: getToken()
    });
}

const getResume = async function (path, type, param, allStatus = false) {

    if (param !== undefined && param !== null) {

        if ((type === "id" && param > 0) || (type === "id" && param !== '') || (type === 'code' && param !== '')) {

            let pathSend = path + "/resume/?type=" + type + "&id="

            if (type === 'id') {
                pathSend += param
            } else {
                pathSend += param
            }

            if (allStatus) {
                pathSend += "&allStatus=true"
            }


            return customAxios.get(pathSend, {
                headers: getToken()
            }).then(response => {
                return response.data
            })


        } else {
            return Promise.reject("")
        }

    } else {
        return Promise.reject("")
    }


}


const count = async function (path, foreignKey) {

    let url = path + "/count/?foreignKey=" + foreignKey

    return customAxios.get(url, {
        headers: getToken()
    }).then(response => {
        return response.data
    });
}


const post = async function (path, data) {

    return customAxios.post(path, data, {
        headers: getToken()
    })
}


const put = async function (path, data) {
    return customAxios.put(path, data, {
        headers: getToken()
    })
}

const remove = async function (path, id) {

    let pathSend = path

    if (path.substring(path.length - 1) !== '/') {
        pathSend = pathSend + "/"
    }

    return customAxios.delete(pathSend + id, {
        headers: getToken()
    });
}

const removeByPath = async function (path) {
    console.log('interno: ' + path)
    return customAxios.delete(path, {
        headers: getToken()
    });
}



const uploadByMultipart = function (path, file, foreignKey, type, onUploadProgress) {

    let formData = new FormData()
    formData.append("id", foreignKey)
    formData.append("type", type)
    //formData.append("file", file)

    return customAxios.post(path, formData, {
        headers: getToken("multipart/form-data"), onUploadProgress
    });

}

const uploadByChunks = function (path, id, foreignKey, type, fileName, fileSize, fileType, chunk, chunks, file, subtitle, categoryId, otherForeignKey) {

    const uploadChunk = {
        id,
        foreignKey,
        type,
        fileName,
        fileSize,
        fileType,
        chunk,
        chunks,
        file,
        subtitle,
        categoryId,
        otherForeignKey
    }

    return this.post(path,uploadChunk)


    /*let formData = new FormData()
    formData.append("id", id)
    formData.append("foreignKey", foreignKey)
    formData.append("type", type) //I ou D
    formData.append("fileName", fileName)
    formData.append("fileSize", fileSize)
    formData.append("fileType", fileType)
    formData.append("chunk", chunk)
    formData.append("chunks", chunks)
    formData.append("file", chunkFile)
    formData.append("subtitle", "Teste 123456")
    formData.append("category", "5")
    formData.append("otherForeignKey", "395")

    return customAxios.post(path, formData, {
        headers: getToken("multipart/form-data"),
    });*/

}


const download = async function (path, nameSalve) {

    return customAxios.get(path, {
        responseType: "blob", headers: getToken()
    }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', nameSalve); //or any other extension
        document.body.appendChild(link);
        link.click();
    })
}

const downloadPost = async function (path, nameSalve, post) {

    return customAxios.post(path, post, {
        responseType: "blob", headers: getToken()
    }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', nameSalve); //or any other extension
        document.body.appendChild(link);
        link.click();
    })
}

const image = async function (path) {

    return customAxios.get(path, {
        responseType: "blob", headers: getToken()
    }).then(response => {
        return URL.createObjectURL(response.data)
    })
}

const list = async function (path, params) {

    let url = ""

    if (params && Array.from(params).length > 0) {
        url += `?${params}`
    }

    //console.log("url list: " + url)

    return await customAxios.get(path + url, {
        headers: getToken()
    }).then(response => {
        return response.data
    })

}

export default {
    customAxios,
    get,
    getAssemble,
    getAll,
    getById,
    getResume,
    post,
    put,
    remove,
    removeByPath,
    list,
    uploadByMultipart,
    uploadByChunks,
    download,
    downloadPost,
    image,
    count,
};




